module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "bbb-rw",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s001BookTitlePage01"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s002Copyright01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s004Part001"
    }
  }, [_vm._v("All the Pretty Little Horses")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s006Chapter001"
    }
  }, [_vm._v("Chapter 1: What We Lost")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s008Chapter003"
    }
  }, [_vm._v("Chapter 2: What We Found")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s010Chapter005"
    }
  }, [_vm._v("Chapter 3: What We Gave Away")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s012Chapter007"
    }
  }, [_vm._v("Chapter 4: What We Stole")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s015Part02"
    }
  }, [_vm._v("Extras")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s016AboutTheAuthor01"
    }
  }, [_vm._v("Meet the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s017AdCard01"
    }
  }, [_vm._v("By Mira Grant")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s018Teaser01"
    }
  }, [_vm._v("A Preview of \"Into the Drowning Deep\"")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s022BackAd01"
    }
  }, [_vm._v("About Orbit Short Fiction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s023Appendix01"
    }
  }, [_vm._v("Newsletters")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "ccc-rw",
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("\n    Navigation\n   ")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/Text/s005Epigraph001#Epigraph1"
    }
  }, [_vm._v("\n      Begin Reading\n     ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/Text/TOC"
    }
  }, [_vm._v("\n      Table of Contents\n     ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-875fd628","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0